import React from "react";
import { companyInfo, navLinks } from "../data/mockData";
import { ArrowUp } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-[#1d1d1f] text-white">
      <div className="max-w-[1200px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img
              src="/uploads/o6xalfl3_logo1.png"
              alt="Brinckmann Arbeitsbühnen"
              className="h-12 object-contain mb-4"
            />
            <p className="text-sm text-white/40 leading-relaxed max-w-xs">
              Ihr zuverlässiger Partner für die bundesweite Vermietung von
              Arbeitsbühnen und Höhenzugangstechnik.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-5">
              Navigation
            </h4>
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-5">
              Kontakt
            </h4>
            <div className="flex flex-col gap-3 text-sm text-white/60">
              <p>{companyInfo.address}</p>
              <p>Tel.: {companyInfo.phone}</p>
              <a
                href={`mailto:${companyInfo.email}`}
                className="hover:text-white transition-colors"
              >
                {companyInfo.email}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            © {new Date().getFullYear()} {companyInfo.fullName}. Alle Rechte
            vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="/agb"
              onClick={(e) => { e.preventDefault(); navigate("/agb"); }}
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              AGB
            </a>
            <button
              onClick={() => navigate("/datenschutz")}
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Datenschutz
            </button>
            <button
              onClick={() => navigate("/cookies")}
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Cookies
            </button>
            <button
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Cookie-Einstellungen
            </button>
            <button
              onClick={() => navigate("/impressum")}
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Impressum
            </button>
            <button
              onClick={scrollToTop}
              className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors"
            >
              <ArrowUp size={14} className="text-white/50" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
